import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";

import "isomorphic-fetch";
import { polyfill } from "es6-promise";
import {
  OFLC_REVOKE_INVITATION,
  revokeInvitationSuccess,
  revokeInvitationFail
} from "../actions/action_revokeInvitation";
import util from "../../../global/utils/Helpers";
polyfill();

let apiIndex = util.isLocalhost()
  ? "http://localhost:9393/auth/graphql"
  : `${util.getCurrentHost()}/auth/auth/graphql`;

const getQuery = data => {
  const query = JSON.stringify({
    query: `
            mutation {
			revokeInvitation(
			email:"${data.props.recipientEmail}",
			group_id:"${data.currentUser.Group.id}")
          }`
  });
  return query;
};
const revokeInvitationEpic = action$ =>
  action$.pipe(
    ofType(OFLC_REVOKE_INVITATION),
    mergeMap(action =>
      fetch(apiIndex, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: getQuery(action.payload)
      })
        .then(response => response.json())
        .then(data => revokeInvitationSuccess(data))
        .catch(error => revokeInvitationFail(true))
    )
  );

export default revokeInvitationEpic;
